.headerContainer {
    padding-bottom: 40px;
}

.iconOutcomeContainer {
    padding: 0 .375rem 0 0;
}

.overviewRating {
    display: flex;
    margin: 0rem 0rem 1rem;
}
.controlsDetails {
    display: flex;
    align-items: center;
    gap: 20px;
}
.textButtonRow {
    display: flex;
    justify-content: space-between;
    flex-direction: row-reverse;
    align-items: center;
    margin: 20px 0px 0px;
}

.tooltip {
    margin-left: 0.375rem;
    display: flex;
    align-items: center;
    justify-content: center;
}
